import { useQuery } from "@apollo/client";

import { GET_API_KEY } from "./gql";

type UseGetApiKeyProps = {
  id?: string;
};

const useGetApiKey = ({ id }: UseGetApiKeyProps) => {
  const { data, loading, error, refetch } = useQuery(GET_API_KEY, {
    variables: { id },
    skip: !id,
  });

  const apiKey = data?.apiKey;

  return { apiKey, loading, error, refetch };
};

export default useGetApiKey;
